import { alpha, styled } from '@mui/material';

import type { NoteOwnerState } from '../Note.types';

export const NoteRoot = styled('div', {
  name: 'Note',
  slot: 'root',
})<{ ownerState: NoteOwnerState }>(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  borderLeft: '4px solid',
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  variants: [
    {
      props: { variant: 'error' },
      style: {
        borderColor: theme.palette.error.main,
        backgroundColor: alpha(theme.palette.error.main, 0.06),
      },
    },
    {
      props: { variant: 'warning' },
      style: {
        borderColor: theme.palette.warning.main,
        backgroundColor: alpha(theme.palette.warning.main, 0.06),
      },
    },
    {
      props: { variant: 'info' },
      style: {
        borderColor: theme.palette.info.main,
        backgroundColor: alpha(theme.palette.info.main, 0.06),
      },
    },
    {
      props: { variant: 'success' },
      style: {
        borderColor: theme.palette.success.main,
        backgroundColor: alpha(theme.palette.success.main, 0.06),
      },
    },
  ],
}));
